"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxGroup = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./checkbox-group.less");
let CheckboxGroup = class CheckboxGroup extends react_1.Component {
    render() {
        const { data = [], renderItem } = this.props;
        return React.createElement("div", { className: "checkbox-group" }, data.map(renderItem));
    }
};
CheckboxGroup = __decorate([
    mobx_react_1.observer
], CheckboxGroup);
exports.CheckboxGroup = CheckboxGroup;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/checkbox-group/checkbox-group.tsx
// module id = 3624
// module chunks = 0